import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NbActionsModule,
  NbBadgeModule,
  NbButtonGroupModule,
  NbButtonModule, NbCalendarModule, NbCalendarRangeModule, NbCardModule,
  NbCheckboxModule, NbDatepickerModule, NbDialogModule, NbFormFieldModule, NbIconModule,
  NbInputModule, NbLayoutModule, NbPopoverModule,
  NbRadioModule, NbSelectModule,
  NbSpinnerModule,
  NbToggleModule,
  NbTooltipModule,
  NbAlertModule
} from '@nebular/theme';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedInputValidatorComponent } from './components/shared-input-validator/shared-input-validator.component';
import { SharedInputValidatorItemComponent } from './components/shared-input-validator/shared-input-validator-item/shared-input-validator-item.component';
import { SharedNotFoundPageComponent } from './components/shared-not-found-page/shared-not-found-page.component';
import { CommonTranslateModule } from '../common-modules/common-translate/common-translate.module';
import { SharedInputPhoneNumberComponent } from './components/shared-input-phone-number/shared-input-phone-number.component';
import { InternationalPhoneNumber2Module } from 'ngx-international-phone-number2';
import { GenericValidationModalComponent } from './components/generic-validation-modal/generic-validation-modal.component';
import { VibrateDirective } from './directives/vibrate.directive';
import { DateFilterButtonComponent } from './components/date-filter-button/date-filter-button.component';
import { DateFilterComponent } from './components/date-filter-button/date-filter/date-filter.component';
import { PipesModule } from './pipes/pipes.module';
import { SharedTrackingProgressBarComponent } from './components/shared-tracking-progress-bar/shared-tracking-progress-bar.component';
import { BasicHelperIconComponent } from './components/basic-helper-icon/basic-helper-icon.component';
import { CustomListModule } from "./components/shared-list/custom-list.module";
import { RouterModule } from '@angular/router';
import { LinkDisplayColumnComponent } from './components/link-display-column/link-display-column.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { EntityEditModalComponent } from './components/entity-edit-modal/entity-edit-modal.component';
import { UISwitcherComponent } from './components/ui-switcher/ui-switcher.component';
import { FuelIconColumnComponent } from './components/fuel-icon-column/fuel-icon-column.component';
import { DynamicFiltersComponent } from './components/dynamic-filters/dynamic-filters.component';
import { PercentRenderComponent } from './components/percent-render/percent-render.component';
import { LevelOfExperienceRenderComponent } from './components/level-of-experience-render/levelOfExperience-render.component';
import { SharedAlertComponent } from './components/shared-alert/shared-alert.component';
import { SharedCheckboxValidatorComponent } from './components/shared-checkbox-validator/shared-checkbox-validator.component';
import { SharedCheckboxValidatorItemComponent } from './components/shared-checkbox-validator/shared-checkbox-validator-item/shared-checkbox-validator-item.component';

@NgModule({
  declarations: [
    SharedInputValidatorComponent,
    SharedInputValidatorItemComponent,
    SharedNotFoundPageComponent,
    SharedInputPhoneNumberComponent,
    GenericValidationModalComponent,
    VibrateDirective,
    DateFilterButtonComponent,
    DateFilterComponent,
    SharedTrackingProgressBarComponent,
    BasicHelperIconComponent,
    LinkDisplayColumnComponent,
    ConfirmationDialogComponent,
    EntityEditModalComponent,
    UISwitcherComponent,
    FuelIconColumnComponent,
    DynamicFiltersComponent,
    PercentRenderComponent,
    LevelOfExperienceRenderComponent,
    SharedAlertComponent,
    SharedCheckboxValidatorComponent,
    SharedCheckboxValidatorItemComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NbInputModule,
    NbCheckboxModule,
    NbSpinnerModule,
    NbToggleModule,
    NbButtonModule,
    NbRadioModule,
    NbSelectModule,
    CommonTranslateModule,
    InternationalPhoneNumber2Module,
    NbLayoutModule,
    NbCardModule,
    NbDialogModule.forChild(),
    NbPopoverModule,
    NbButtonGroupModule,
    NbBadgeModule,
    NbTooltipModule,
    PipesModule,
    NbCalendarRangeModule,
    NbCalendarModule,
    NbFormFieldModule,
    NbIconModule,
    CustomListModule,
    RouterModule,
    NbDatepickerModule,
    NbActionsModule,
    NbAlertModule
  ],
  exports: [
    NbInputModule,
    NbCheckboxModule,
    ReactiveFormsModule,
    SharedInputValidatorComponent,
    SharedInputValidatorItemComponent,
    NbSpinnerModule,
    NbToggleModule,
    SharedNotFoundPageComponent,
    NbButtonModule,
    NbRadioModule,
    SharedInputPhoneNumberComponent,
    VibrateDirective,
    DateFilterButtonComponent,
    SharedTrackingProgressBarComponent,
    BasicHelperIconComponent,
    LinkDisplayColumnComponent,
    ConfirmationDialogComponent,
    CustomListModule,
    UISwitcherComponent,
    FuelIconColumnComponent,
    DynamicFiltersComponent,
    PercentRenderComponent,
    LevelOfExperienceRenderComponent,
    SharedAlertComponent,
    SharedCheckboxValidatorItemComponent,
    SharedCheckboxValidatorComponent
  ]
})
export class SharedModule {}
